import Login from "../Login/Login";
import { Navigate, Route, Routes } from "react-router-dom";
import AdminLayout from "../Router/AdminLayout";
import Dashboard from "../pages/Dashboard/Dashboard";
import AuthorListing from "../pages/Author/AuthorListing";
import Category from "../pages/category/Category";
import Tags from "../pages/tags/Tags";
import BlogListing from "../pages/blogs/BlogListing";
import AddBlog from "../pages/blogs/AddBlog";
import EditBlog from "../pages/blogs/EditBlog";
import Contact from "../pages/Contact/Contact";
import SeoListing from "../pages/Seo/SeoListing";
import SeoCreate from "../pages/Seo/SeoCreate";
import SeoEdit from "../pages/Seo/SeoEdit";
import Project from "../pages/projectModule/projects/Project";
import AddProject from "../pages/projectModule/projects/AddProject";
import EditProject from "../pages/projectModule/projects/EditProject";
import ProjectCat from "../pages/projectModule/projectCategory/ProjectCat";
import Career from "../pages/Career/Career";
import NewsListing from "../pages/News/NewsListing";
import NewsCreate from "../pages/News/NewsCreate";
import NewsEdit from "../pages/News/NewsEdit";
import ProductcatList from "../pages/Product/ProductCategory/ProductcatList";
import ProductcatAdd from "../pages/Product/ProductCategory/ProductcatAdd";
import ProductcatEdit from "../pages/Product/ProductCategory/ProductcatEdit";
import ProductsListing from "../pages/Product/Products/ProductsListing";
import ProductAdd from "../pages/Product/Products/ProductAdd";
import ProductEdit from "../pages/Product/Products/ProductEdit";
import Dynamic from "../pages/DynamicPage/Dynamic";
import AddDynamic from "../pages/DynamicPage/AddDynamic";
import EditDynamic from "../pages/DynamicPage/EditDynamic";
import FaqListing from "../pages/Faq/FaqListing";
import AddFaq from "../pages/Faq/AddFaq";
import EditFaq from "../pages/Faq/EditFaq";
import SitemapEditor from "../pages/sitemap/SitemapEditor";
import SchemaManagement from "../pages/schema-management/SchemaManagement";
import LlmsManagement from "../pages/Llms/LlmsManagement";
import RobotsManagement from "../pages/Robots/RobotsManagement";
import EmailManagement from "../pages/EmailManagement/EmailManagement";
import AddEmailManagement from "../pages/EmailManagement/AddEmailManagement";
import EditEmailManagement from "../pages/EmailManagement/EditEmailManagement";
import Users from "../pages/Rbac/Users";
import Roles from "../pages/Rbac/Roles";
import Permissions from "../pages/Rbac/Permissions";


export default function Router() {
  return (
    <>
      <Routes>
        <Route path={"login"} element={<Login />} />
        <Route path="/" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />

          <Route path="users" element={<Users />} />
          <Route path="roles" element={<Roles />} />
          <Route path="permissions" element={<Permissions />} />

          <Route path="author" element={<AuthorListing />} />
          <Route path="category" element={<Category />} />
          <Route path="tag" element={<Tags />} />
          <Route path="blog" element={<BlogListing />} />
          <Route path="add-blog" element={<AddBlog />} />
          <Route path="edit-blog/:blog_id" element={<EditBlog />} />
          {/* dymanic */}
          <Route path="dynamic" element={<Dynamic />} />
          <Route path="add-dynamic" element={<AddDynamic />} />
          <Route path="edit-dynamic/:dynamicpage_id" element={<EditDynamic />} />

          <Route path="contact" element={<Contact />} />

          <Route path="seo" element={<SeoListing />} />
          <Route path="add-seo" element={<SeoCreate />} />
          <Route path="edit-seo/:seo_id" element={<SeoEdit />} />

          <Route path="faq" element={<FaqListing />} />
          <Route path="add-faq" element={<AddFaq />} />
          <Route path="edit-faq/:faq_id" element={<EditFaq />} />

          <Route path="sitemap" element={<SitemapEditor />} />
          <Route path="global-seo" element={<SchemaManagement />} />
          <Route path="schema-management" element={<Navigate to="/global-seo" replace />} />
          <Route path="llms" element={<LlmsManagement />} />
          <Route path="robots" element={<RobotsManagement />} />
          <Route path="email-management" element={<EmailManagement />} />
          <Route path="add-email-management" element={<AddEmailManagement />} />
          <Route path="edit-email-management/:dynamicemail_id" element={<EditEmailManagement />} />

          <Route path="project" element={<Project />} />
          <Route path="add-project" element={<AddProject />} />
          <Route path="edit-project/:project_id" element={<EditProject />} />
          <Route path="project-category" element={<ProjectCat />} />

          <Route path="news" element={<NewsListing />} />
          <Route path="add-news" element={<NewsCreate />} />
          <Route path="edit-news/:media_id" element={<NewsEdit />} />

          <Route path="career" element={<Career />} />

          <Route path="product" element={<ProductsListing />} />
          <Route path="add-product" element={<ProductAdd />} />
          <Route path="edit-product/:product_id" element={<ProductEdit />} />

          <Route path="product-category" element={<ProductcatList />} />
          <Route path="add-product-category" element={<ProductcatAdd />} />
          <Route path="edit-product-category/:productcategory_id" element={<ProductcatEdit />} />

        </Route>
      </Routes>
    </>
  )
}
